export default __webpack_public_path__ + "static/media/Rodriguez.88aa201e.jpg";